<div class="flex-1 overflow-auto">
    <kui-card-header class="header d-flex align-items-center text-left p-3 overflow-hidden">
        <kui-card-title class="content-card-title card-title d-block">{{handler.title}}</kui-card-title>
        <ul class="content-card-actions">
            <li *ngIf="handler.actionAdd">
                <kui-icon kui-action
                    name="plus"
                    (click)="actionClicked('add', null)"
                    title="{{ 'SHARED.ADD' | translate }}"></kui-icon>
            </li>
            <li *ngIf="handler.actionReload">
                <kui-icon kui-action
                    name="redo"
                    (click)="refresh()"
                    title="{{ 'SHARED.REFRESH' | translate }}"></kui-icon>
            </li>
        </ul>
    </kui-card-header>
    <div>

        <div *ngIf="((!items || items.length === 0) && (!componentRefs || componentRefs.length === 0)) && handler.emptyText"
            class="p-4 border-bottom d-flex">
            <div>
                <kui-icon class="section-icon icon-light mr-3"
                    [fixedWidth]="true"
                    [name]="'exclamation-triangle'"
                    [size]="'xl'"></kui-icon>

            </div>
            <div class='flex-1'>
                <div>{{handler.emptyText}}</div>
            </div>
            <div class='text-right pl-3'
                *ngIf="handler.actionAdd">
                <button (click)="actionClicked('add', null)"
                    kui-button>
                    {{ 'SHARED.ADD' | translate }}
                </button>
            </div>
        </div>

        <template #templateContainer></template>

        <key-listing *ngFor="let item of items"
            [hover]="true">

            <key-listing-avatar class="icon-light p-1"
                *ngIf="item.icon"
                (click)="onSelected(item)">
                <kui-icon [name]="item.icon"
                    [fixedWidth]="true"
                    [size]="'xl'"></kui-icon>
            </key-listing-avatar>

            <div class="d-flex flex-row">
                <div class='flex-1'
                    (click)="onSelected(item)">
                    <key-listing-title>{{item.name}}</key-listing-title>
                    <key-listing-description>
                        <div class="pt-1 muted"
                            [innerHTML]="item.description"></div>
                    </key-listing-description>
                </div>
                <div class='d-flex flex-column'
                    *ngIf="handler.actionDelete">
                    <div (click)="onDelete(item)">
                        <kui-icon name="trash-alt"
                            title="{{ 'SHARED.DELETE' | translate }}"
                            [size]="'sm'"
                            class="ml-3 icon-light"></kui-icon>
                    </div>
                </div>
            </div>

        </key-listing>
    </div>
</div>